import type { ComponentProps } from "react";

export function Close(props: ComponentProps<"svg">) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 16 16"
			fill="none"
			aria-hidden="true"
			{...props}
		>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={1.5}
				d="m4.464 4.464 7.071 7.072M4.464 11.536l7.071-7.072"
			/>
		</svg>
	);
}
